const ArticleList = () => import('../../components/article-list/index.vue');

export default {
    components: {
        'article-list': ArticleList,
    }
};